import React from 'react'
import { PropTypes } from 'prop-types'

import { Button, Container } from '@sainsburys-tech/fable'

import TickInCircle from '../../assets/TickInCircle.svg'
import timerIcon from '../../assets/TimerIcon.svg'
import CrossInCircle from '../../assets/CrossInCircle.svg'
import BlackInfoIcon from '../../assets/BlackInfoIcon.svg'
import HandBackPassModal from '../Passes/HandbackPassModal'
import redirectUser from '../../utils/routeHelper'
import LoadingOverlay from '../LoadingOverlay'

class WorkOrderContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pluraliseBtntext: 'pass',
      icon: <img src={timerIcon} alt="timer" />,
      wording: '',
      authorised: false,
      authorisedText: 'OK, you can start work now',
      pending: null,
      pendingText: 'Wait for manager\'s authorisation',
      rejected: false,
      rejectedText: 'Rejected - do not start work',
      handBackPassModalOpen: false,
      handedBackToastOpen: false,
      loading: false
    }
  }

  componentWillReceiveProps = () => {
    this.setPassAuthorisationStatus()
  }

  setPassAuthorisationStatus = () => {
    const { permits, status, text } = this.props
    const { authorisedText, pendingText, rejectedText } = this.state

    if (permits && permits.props && permits.props.children && permits.props.children.length > 1) {
      this.setState({ pluraliseBtntext: 'passes' })
    }

    switch (status) {
      case 'authorised':
        this.setState({ authorised: true, wording: text || authorisedText, icon: <img src={TickInCircle} alt="tick" /> })
        break
      case 'pending':
        this.setState({ pending: 'info', wording: text || pendingText, icon: <img src={timerIcon} alt="timer" /> })
        break
      case 'rejected':
        this.setState({ rejected: true, wording: text || rejectedText, icon: <img src={CrossInCircle} alt="cross" /> })
        break
      default:
        this.setState({ rejected: true, wording: 'Status must be a string and one of authorised, pending, or rejected' })
        break
    }
  }

  openHandBackModal = () => {
    this.setState({ handBackPassModalOpen: true })
  }

  closeHandBackModal = () => {
    const { history, loadingCallback } = this.props
    this.setState({ handBackPassModalOpen: false, handedBackToastOpen: true, loading: false })
    loadingCallback(true)
    redirectUser(history)
  }

  loadingCallback = (loading) => {
    this.setState({ loading })
  }

  showHandBackPassModal = () => {
    const { handBackPassModalOpen, pluraliseBtntext } = this.state
    const { permits } = this.props

    const isPlural = Boolean(permits && permits.props && permits.props.children && permits.props.children.length > 1)

    return (
      <HandBackPassModal
        loadingCallback={this.loadingCallback}
        open={handBackPassModalOpen}
        handleClose={() => this.setState({ handBackPassModalOpen: false })}
        title={pluraliseBtntext}
        isPlural={isPlural}
        closeHandBackModal={this.closeHandBackModal}
      />
    )
  }

  displayNoWorkOrders = () => {
    const { workOrdersLength, hasPassesHandedBack } = this.props
    return (
      <div className="dsib-workOrderContainer">
        <div className="dsib-workOrderContainer__card dsib-workOrderContainer__card--hard">
          {hasPassesHandedBack ? this.displayHandedBackToastMessage() : null}
          <p className="dsib-workOrderContainer__cardText">
            Please remember to sign out when you leave the site.
          </p>
          {workOrdersLength !== 0 && (
            <div className="dsib-workOrderContainer__emptyCard">
              No open work orders
            </div>
          )}
        </div>
        {this.displaySelectAnotherWOPrompt()}
      </div>
    )
  }

  displaySelectAnotherWOPrompt = () => (
    <div className="dsib-workOrderContainer__prompt">
      To select another work order or pass you need to sign out and sign in again.
    </div>
  )

  displayWorkOrderStatus = () => {
    const {
      workOrderNumber,
      status,
      permits,
      hasPassesHandedBack
    } = this.props

    const {
      authorised,
      pending,
      rejected,
      icon,
      wording,
      pluraliseBtntext
    } = this.state

    let statusVariant = 'info'
    if (authorised) statusVariant = 'success'
    else if (rejected) statusVariant = 'error'

    return (
      (workOrderNumber && status && !hasPassesHandedBack) ? (
        <div className="dsib-workOrderContainer">
          <Container as="div" className="dsib-workOrderContainer__card dsib-workOrderContainer__card--hard">
            <h3 className="dsib-workOrderContainer__workOrderTitle">{`Work order: ${workOrderNumber}`}</h3>

            <div className={`dsib-workOrderContainer__status dsib-workOrderContainer__status--${statusVariant}`} role="status" aria-live="polite">
              <div className="dsib-workOrderContainer__statusIcon">
                {icon}
              </div>
              <div className="dsib-workOrderContainer__statusText">{wording}</div>
            </div>

            {permits}

            {(permits && permits.props && permits.props.children && permits.props.children.length > 0 && authorised) && (
              <div className="dsib-workOrderContainer__cta">
                <Button isFullWidth variant="primary" onClick={this.openHandBackModal}>
                  {`Hand back ${pluraliseBtntext}`}
                </Button>
              </div>
            )}
          </Container>

          {this.displaySelectAnotherWOPrompt()}
        </div>
      )
        : (
          this.displayNoWorkOrders()
        )
    )
  }

  displayHandedBackToastMessage = () => {
    const {
      handedBackToastOpen,
      pluraliseBtntext
    } = this.state

    const caplitalisedPluralText = pluraliseBtntext.charAt(0).toUpperCase() + pluraliseBtntext.slice(1)

    if (!handedBackToastOpen) return null

    return (
      <div className="dsib-workOrderContainer__toast" role="status" aria-live="polite">
        <div className="dsib-workOrderContainer__toastIcon">
          <img src={BlackInfoIcon} alt="information" />
        </div>
        <div className="dsib-workOrderContainer__toastText">{`${caplitalisedPluralText} handed back`}</div>
      </div>
    )
  }

  render() {
    const { loading } = this.state
    const { permits } = this.props

    const isPlural = Boolean(permits && permits.props && permits.props.children && permits.props.children.length > 1)

    return (
      <div>
        {this.showHandBackPassModal()}
        {
          this.displayWorkOrderStatus()
        }
        {loading
          && <LoadingOverlay hasBackground text={`Handing back ${isPlural ? 'passes' : 'pass'}...`} />
        }
      </div>
    )
  }
}

WorkOrderContainer.propTypes = {
  workOrderNumber: PropTypes.string,
  status: PropTypes.oneOf(['authorised', 'pending', 'rejected']),
  workOrdersLength: PropTypes.number.isRequired,
  permits: PropTypes.node,
  text: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  hasPassesHandedBack: PropTypes.bool.isRequired,
  loadingCallback: PropTypes.func.isRequired,
}

WorkOrderContainer.defaultProps = {
  workOrderNumber: '',
  status: 'authorised',
  permits: null,
  text: null,
}


export default WorkOrderContainer
